import type { FaireProductEntity } from "../../entity_types/product";

export const toysmith_19: FaireProductEntity = {
  token: "toysmith-19",
  type: "product",
  name: "Farm Fresh Barnyard Squealer Balloons That Squeal & Fly",
  brandName: "Toysmith",
  imageUrl:
    "https://cdn.faire.com/fastly/f013c6d4ec64bb43baebe1e12ae31724480e9312ee9b7fb2af2f10c6bfcaa74e.jpeg?bg-color=FFFFFF&canvas=720:720&dpr=1&fit=bounds&format=jpg&height=720&width=720",
  priceDollars: 7,
  msrpDollars: 14,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-toys"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
